export { default as GDMTable } from './GDMTable';

export type { GDMTableComponent, GDMTableProps } from './GDMTable.type';
